import {useCart, Money, ClientAnalytics} from '@shopify/hydrogen';
import PropTypes from 'prop-types';
import {CartDetails} from './CartDetails.client';
import {Button} from '~/components/global/Button.client';
import {trackClickEvent} from '~/utils/trackClickEvent';
import {MultipassCheckoutButton} from '~/components/global/MultipassCheckoutButton.client';

/*
 * CartOverlay component provides the shopping cart items in a slide out overlay.
 * It is triggered on desktop by hovering 'cart-overlay-trigger' and on mobile by clicking 'cart-overlay-trigger'.
 * It accepts a toggleCartOverlayVisibility function that is passed down from UserNav.client.jsx to manage the state of the overlay.
 * Shares most components with the actual cart page, Cart.client.jsx
 */

export function CartOverlay({visibility, toggleCartOverlayVisibility}) {
  const {lines, totalQuantity, cost} = useCart();

  const cartClick = () => {
    ClientAnalytics.publish('view_cart', true, {
      lines,
      cost,
    });
  };

  return (
    <div className="cart-overlay cart-overlay__wrapper">
      <button
        className="cart-overlay__continue-shopping cart-overlay-trigger"
        onClick={() => {
          trackClickEvent('toggle_cart_overlay_visibility');
          toggleCartOverlayVisibility();
          if (visibility) {
            cartClick();
          }
        }}
      >
        Continue Shopping
      </button>
      {totalQuantity > 0 ? (
        <>
          <CartOverlayActions />
          <CartDetails />
        </>
      ) : (
        <div className="cart-overlay__display-empty">Your Cart Is Empty</div>
      )}
    </div>
  );
}

function CartOverlayActions() {
  const {checkoutUrl, lines, cost} = useCart();
  const handleCheckoutClick = (e) => {
    const closestH1 = document.querySelector('h1');
    const item_list_name = closestH1 ? closestH1.textContent.trim() : '';
    const event_details = {
      lines,
      cost,
      item_list_name,
      e,
    };
    trackClickEvent('begin_checkout', event_details);
  };

  return (
    <>
      <div className="cart-overlay__actions">
        {cost?.subtotalAmount?.amount && (
          <div className="cart-overlay cart-overlay__subtotal">
            <span className="label">Subtotal:</span>
            <Money data={cost?.subtotalAmount} />
          </div>
        )}
        <div className="cart-overlay cart-overlay__cart-buttons">
          {checkoutUrl ? (
            <MultipassCheckoutButton checkoutUrl={checkoutUrl}>
              <Button
                href={checkoutUrl}
                ctaText="Checkout"
                variant="primary"
                onClick={handleCheckoutClick}
              />
            </MultipassCheckoutButton>
          ) : null}
          <Button
            href="/cart"
            ctaText="View Cart"
            variant="secondary"
            onClick={() => {
              trackClickEvent('click_view_cart_link');
            }}
          />
        </div>
      </div>
    </>
  );
}

CartOverlay.propTypes = {
  toggleCartOverlayVisibility: PropTypes.func,
};
